import BrowserWarning from  './browserwarning';

export default BrowserWarning;